<template>
  <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.7793 3.36865H18.4834" stroke="currentColor"/>
    <path d="M16.1175 1.01663L16.137 3.42706L16.1485 5.72062" stroke="currentColor"/>
    <path d="M7.75719 1.1888C7.69693 1.12805 7.62525 1.07983 7.54626 1.04692C7.46728 1.01401 7.38256 0.99707 7.29699 0.99707C7.21142 0.99707 7.1267 1.01401 7.04772 1.04692C6.96873 1.07983 6.89704 1.12805 6.83679 1.1888L1.00325 7.02234C0.942499 7.08259 0.894279 7.15428 0.861372 7.23327C0.828465 7.31225 0.811523 7.39697 0.811523 7.48254C0.811523 7.5681 0.828465 7.65282 0.861372 7.73181C0.894279 7.81079 0.942499 7.88248 1.00325 7.94274C1.06382 8.00281 1.13564 8.05034 1.21462 8.08259C1.29359 8.11485 1.37815 8.1312 1.46345 8.13071H2.11162V12.6679C2.11162 13.0117 2.2482 13.3414 2.49131 13.5846C2.73442 13.8277 3.06415 13.9642 3.40796 13.9642H11.186C11.5298 13.9642 11.8596 13.8277 12.1027 13.5846C12.3458 13.3414 12.4824 13.0117 12.4824 12.6679V8.13071H13.1305C13.3024 8.13071 13.4673 8.06242 13.5889 7.94086C13.7104 7.81931 13.7787 7.65444 13.7787 7.48254C13.7792 7.39723 13.7628 7.31267 13.7306 7.2337C13.6983 7.15473 13.6508 7.0829 13.5907 7.02234L7.75719 1.1888ZM3.40796 12.6679V6.45195L7.29699 2.56292L11.186 6.45195V12.6679H3.40796Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconPresetAll',
  }
</script>

<style scoped>

</style>
